import { ReactNode } from 'react';

import { IconCloseMS, IconDescriptionMS } from '../../../../constants/icons';
import {
  ReportFileIcon,
  ReportFileName,
  ReportFileRow,
  ReportFileSize,
  ReportRemoveButton,
} from './styles';

interface AttachedFileRowProps {
  file: File;
  /** Texto do `title` do botão de remover — muda entre laudo e anexo. */
  removeTitle: string;
  onRemove: () => void;
  /** Controles extras à direita do nome, hoje o select de tipo do anexo. */
  children?: ReactNode;
}

const formatFileSize = (bytes: number): string => {
  const kb = bytes / 1024;
  if (kb < 1024) return `${Math.max(1, Math.round(kb))} KB`;
  return `${(kb / 1024).toFixed(1)} MB`;
};

/**
 * Um arquivo já escolhido, como LINHA e não como rótulo de botão.
 *
 * O nome do arquivo virar o texto de um botão de 150px era o pior estado da
 * tela: aparecia só depois de escolher, que é justamente quando a pessoa
 * precisa conferir o que escolheu. Aqui ele trunca com reticências e o nome
 * inteiro fica no `title`, disponível no hover.
 *
 * Laudo e "outros documentos" usam a mesma linha de propósito: têm a mesma
 * forma, e duas implementações separadas envelheceriam separadas.
 */
export function AttachedFileRow({
  file,
  removeTitle,
  onRemove,
  children,
}: AttachedFileRowProps): JSX.Element {
  return (
    <ReportFileRow>
      <ReportFileIcon>{IconDescriptionMS}</ReportFileIcon>
      <ReportFileName title={file.name}>{file.name}</ReportFileName>
      <ReportFileSize>{formatFileSize(file.size)}</ReportFileSize>
      {children}
      <ReportRemoveButton
        size="small"
        title={removeTitle}
        aria-label={removeTitle}
        onClick={onRemove}
      >
        {IconCloseMS}
      </ReportRemoveButton>
    </ReportFileRow>
  );
}
